import { ISobAnalyticsReportJoined } from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportJoined'

export interface IBusinessPerformanceByCategory {
  category: string
  data: ISobAnalyticsReportJoined[]
}

export const getBusinessPerformanceDataGroupedByCategory = (
  data: ISobAnalyticsReportJoined[]
): IBusinessPerformanceByCategory[] => {
  const map = data.reduce<Record<string, ISobAnalyticsReportJoined[]>>((acc, item) => {
    const category = item.Category

    if (!category) {
      return acc
    }

    return {
      ...acc,
      [category]: acc[category] ? [...acc[category], item] : [item],
    }
  }, {})

  return Object.entries(map).map(([category, items]) => ({
    category,
    data: items,
  }))
}
